import type { FaireProductEntity } from "../../entity_types/product";

export const p_xgd59bd3xb: FaireProductEntity = {
  token: "p_xgd59bd3xb",
  type: "product",
  name: "Immersive kit Rituel Nordique",
  brandToken: "b_zm6eavqgy2",
  brandName: "SELV RITUEL",
  imageUrl: "https://cdn.faire.com/fastly/aba69874d8a7d8ddad1b9e97be84ddcb6125c4f264a47c65989ce3059244878c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3b1616f97d51ef9964b26c17bf9d3e2d2fbb34e259587de370af3913884db19a.jpeg"
  ],
  priceDollars: 16.5,
  description: "A turnkey bath ritual with lavender and eucalyptus.\n\nIt smells...\n\nLike eucalyptus and lavender.\n\nUse \n\nJust put all the items in the bath, besides the matches.  \n\nYou can use the small wooden spoon and to fill the small tea bag with the very small flowers contained in your kit. You can then infuse this sachet in your bath water as you would a tea bag. \n\n*For external use only. Do not apply to lips, eyes or genitals. \n\nContent \n\nHimalayan Pink Salt, Rose Blossoms, Straw Blossoms, Lavender Blossoms, Eucalyptus Leaves, Lantern, Incense Match Pack, Nordic Ritual Botanical Oil (Eucalyptus Essential Oil, Lavender Essential Oil, Herbal Oil) sweet almond, argan oil, avocado oil, apricot oil and vitamin E). \n\nNatural. Vegan. Handmade.",
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:15.052Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
